'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortLocalTimeoutButLongerWhenProdAndDeployed = shortLocalTimeoutButLongerWhenProdAndDeployed;
exports.cancelUnhandledPolling = cancelUnhandledPolling;
exports.logUnhandledErrorsToConsole = logUnhandledErrorsToConsole;
exports.logUnhandledErrorsAndSendAlerts = logUnhandledErrorsAndSendAlerts;
exports.logUnhandledErrorsAndSendNonApiAlerts = logUnhandledErrorsAndSendNonApiAlerts;

var _schedule = require('./util/schedule');

var _env = require('./util/env');

var _other = require('./util/other');

var UNHANDLED_PREFIX = '[Q Unhandled]';

function logToConsole(reason) {
  if ((0, _other.isInvalidRejection)(reason)) {
    console.error(UNHANDLED_PREFIX, (0, _other.removeNoStackPrefix)(reason), _other.INVALID_REJECTION_SUFFIX);
  } else {
    console.error(UNHANDLED_PREFIX, reason);
  }
}

var sendUnhandledErrorNotifications = (0, _other.sendCleanedErrorNotificationsWithPrefix)(UNHANDLED_PREFIX, { type: 'q-unhandled' });

var checkUnhandled = function checkUnhandled() {
  for (var _len = arguments.length, errorFuncs = Array(_len), _key = 0; _key < _len; _key++) {
    errorFuncs[_key] = arguments[_key];
  }

  return function () {
    var unhandled = Q.getUnhandledReasons();

    // Clear out all existing unhandled rejections
    if (unhandled && unhandled.length > 0) {
      unhandled.forEach(function (unhandledError) {
        return errorFuncs.forEach(function (errorFunc) {
          return errorFunc(unhandledError);
        });
      });

      Q.resetUnhandledRejections();
    }
  };
};

var SHORT_POLLING_TIMEOUT = 1000;
var MEDIUM_POLLING_TIMEOUT = 5000;

function shortLocalTimeoutButLongerWhenProdAndDeployed() {
  if ((0, _env.ifDeployedAndProduction)('unhandledPoller')) {
    return MEDIUM_POLLING_TIMEOUT;
  } else {
    return SHORT_POLLING_TIMEOUT;
  }
}

var determineTimeout = function determineTimeout() {
  var integerOrFunc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shortLocalTimeoutButLongerWhenProdAndDeployed;

  if (typeof integerOrFunc === 'function') {
    var result = integerOrFunc();

    if (typeof result !== 'number') {
      throw new Error('Invalid timeout returned from custom timeout function passed to logUnhandledErrors* call');
    }

    return result;
  } else if (typeof integerOrFunc === 'number') {
    return integerOrFunc;
  } else {
    throw new Error('Invalid timeout passed to logUnhandledErrors* call');
  }
};

// Only allow one handler at a time
var currentCancelFunc = void 0;

function cancelUnhandledPolling() {
  if (currentCancelFunc) {
    currentCancelFunc();
    currentCancelFunc = undefined;
  }
}

function logUnhandledErrorsToConsole() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeout = determineTimeout(options.timeout);
  cancelUnhandledPolling();

  currentCancelFunc = (0, _schedule.scheduleFunctionOnLazyInterval)(checkUnhandled(logToConsole), timeout);
}

function logUnhandledErrorsAndSendAlerts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeout = determineTimeout(options.timeout);
  cancelUnhandledPolling();

  currentCancelFunc = (0, _schedule.scheduleFunctionOnLazyInterval)(checkUnhandled(logToConsole, sendUnhandledErrorNotifications), timeout);
}

function logUnhandledErrorsAndSendNonApiAlerts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeout = determineTimeout(options.timeout);
  cancelUnhandledPolling();

  currentCancelFunc = (0, _schedule.scheduleFunctionOnLazyInterval)(checkUnhandled(logToConsole, (0, _other.ifNonApiReason)(sendUnhandledErrorNotifications)), timeout);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-5.22/js/handleUnhandledErrors.js
// module id = 244
// module chunks = 0